import { useContext } from 'react';
import SecurityContext, { SecurityContextContent } from '../SecurityContext';

const useSecurityContext = (): SecurityContextContent => useContext(SecurityContext);

export default useSecurityContext;
